<script>
const CLOUD_NAME = 'hrmedia';

export default {
  props: {
    src: {
      type: String,
      default: '',
      required: true,
    },
    thumb: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      player: null,
      scriptLoaded: false,
      canplayCalled: false,
    };
  },
  watch: {
    scriptLoaded(newValue) {
      if (newValue === false) return;
      this.initPlayer();
    },
  },
  mounted() {
    // webpackでのバンドルがうまく動かないため
    // ブラウザ環境でcloudinary-video-playerをCDN経由で読み込む
    if (typeof window !== 'undefined' && !window.cloudinary) {
      this.loadCloudinaryPlayer();
    } else if (window.cloudinary) {
      this.scriptLoaded = true;
    }
  },
  beforeDestroy() {
    // プレイヤーインスタンスを破棄
    if (this.player) {
      try {
        this.player.dispose();
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('Failed to dispose player', e);
      }
      this.player = null;
    }
  },
  methods: {
    loadCloudinaryPlayer() {
      // CSSの読み込み
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href =
        'https://unpkg.com/cloudinary-video-player@3.6.3/dist/cld-video-player.min.css';
      document.head.appendChild(link);

      // JavaScriptの読み込み
      const script = document.createElement('script');
      script.src =
        'https://unpkg.com/cloudinary-video-player@3.6.3/dist/cld-video-player.min.js';
      script.onload = () => {
        this.scriptLoaded = true;
      };
      script.onerror = () => {
        // eslint-disable-next-line no-console
        console.error('Failed to load Cloudinary Video Player');
      };
      document.head.appendChild(script);
    },
    initPlayer() {
      // eslint-disable-next-line no-console
      console.log('initPlayer called', {
        src: this.src,
        onCanplay: this.onCanplay,
        onCanplayType: typeof this.onCanplay,
      });

      // 既存のプレイヤーインスタンスがあれば破棄
      if (this.player) {
        try {
          this.player.dispose();
        } catch (e) {
          // eslint-disable-next-line no-console
          console.error('Failed to dispose existing player', e);
        }
        this.player = null;
      }

      // canplayCalledフラグをリセット
      this.canplayCalled = false;

      this.player = window.cloudinary.videoPlayer(
        this.$refs.videoElement,
        {
          cloudName: CLOUD_NAME,
          bigPlayButton: false,
          controls: false,
          hideContextMenu: true,
          autoplay: true,
          loop: true,
          showLogo: false,
          seekThumbnails: false,
          playsinline: true,
          muted: true,
          fluid: true,
          autoplayMode: 'on-scroll',
        },
        () => {},
      );
      // canplayイベントを1回だけ呼ぶ
      this.player.on('canplay', () => {
        if (!this.canplayCalled) {
          this.canplayCalled = true;
          this.$emit('canplay');
        }
      });

      this.player.source(this.src);
    },
  },
};
</script>

<template>
  <video ref="videoElement" class="key-visual-video-player-new"></video>
</template>

<style scoped>
.key-visual-video-player-new {
  width: 100%;
  height: 100% !important;
  object-fit: cover;
}

.key-visual-video-player-new .vjs-text-track-display {
  display: none;
}

/* Cloudinaryプレイヤーが生成するvideo要素にもcoverを適用 */
.key-visual-video-player-new video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/*
iOS端末でのキービジュアル動画表示時に一時停止アイコンを表示させない強硬手段
Cloudinary Video Player が内部で使用している video.js のクラスを指定して再生ボタンを非表示にする
ref: https://docs.videojs.com/big-play-button.js#line32
*/
::v-deep .vjs-big-play-button {
  display: none !important;
}
</style>
